import { LEVEL_KEYS, LineFilter } from './types';

export const normalizeLevelName = (level: string): string => {
  const l = (level || '').toLowerCase().trim();
  if (l === 'warning') return 'warn';
  if (l === 'fatal') return 'critical';
  if (LEVEL_KEYS.includes(l as any)) return l;
  return 'unknown';
};

export const fmtLogTimestamp = (nsEpoch: number): string => {
  const d = new Date(nsEpoch / 1_000_000);
  const pad2 = (n: number) => String(n).padStart(2, '0');
  const pad3 = (n: number) => String(n).padStart(3, '0');
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}.${pad3(d.getMilliseconds())}`;
};

export const toLocalDatetimeStr = (date: Date) => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const fmtDate = (d: Date) => d.toLocaleString('en-GB', {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hour12: false,
});

const escapeRegex = (str: string): string =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const buildSelectorString = (
  selections: Record<string, string[]>,
  lineFilter?: LineFilter | null,
): string => {
  const parts = Object.entries(selections)
    .filter(([, values]) => values.length > 0)
    .map(([k, values]) => {
      if (values.length === 1) return `${k}="${values[0]}"`;
      return `${k}=~"${values.join('|')}"`;
    });
  let selector = parts.length > 0 ? `{${parts.join(',')}}` : '{}';

  if (lineFilter?.value?.trim()) {
    const val = lineFilter.value.trim();
    switch (lineFilter.operator) {
      case 'contains':
        selector += ` |= \`${val}\``;
        break;
      case 'not_contains':
        selector += ` != \`${val}\``;
        break;
      case 'contains_ci':
        selector += ` |~ \`(?i)${escapeRegex(val)}\``;
        break;
      case 'not_contains_ci':
        selector += ` !~ \`(?i)${escapeRegex(val)}\``;
        break;
      case 'regex_match':
        selector += ` |~ \`${val}\``;
        break;
      case 'not_regex_match':
        selector += ` !~ \`${val}\``;
        break;
    }
  }

  return selector;
};
